import { useState, useEffect } from 'react';

const DEFAULT_DEBOUNCE_IN_MS = 300;

export const useDebounce = (value: string, delay = DEFAULT_DEBOUNCE_IN_MS) => {
	const [debouncedValue, setDebouncedValue] = useState(value);

	useEffect(() => {
		const handler = setTimeout(() => {
			setDebouncedValue(value);
		}, delay);

		return () => {
			clearTimeout(handler);
		};
	}, [value, delay]);

	return debouncedValue;
};
